module.exports = __webpack_public_path__ + "img/super-app-android.5740e82f.png";